/** Chats MFE viewer API route-path + paging SSOT: the chats worker entry gates request routing on the base path and builds the viewer/search sub-paths from `CHATS_VIEWER_ROUTES`; the clamps bound the viewer page and search reads. */

import { buildMfeApiBase, MFE_NAMES } from '@federa/const/mfe-names';

export const CHATS_MFE_API_BASE = buildMfeApiBase(MFE_NAMES.CHATS);

/** Same-origin base the EMBEDDED assistant dials. The host middleware strips this prefix and forwards to the chats service ROOT with headers verbatim, so identity rides USER_ID / USER_ROLE. */
export const CHATS_ASSISTANT_API_PREFIX = '/__chats-api';

export const CHATS_VIEWER_ROUTES = {
	CONVERSATIONS: `${CHATS_MFE_API_BASE}/conversations`,
	SEARCH: `${CHATS_MFE_API_BASE}/search`,
} as const;

/** The viewer composes the path and the worker composes the routing regex, so a one-sided rename is a silent 404 -- the regex arm returns `null`, surfacing as an empty thread panel. */
export const CHATS_VIEWER_SUBROUTES = {
	MESSAGES: 'messages',
	PARTICIPANTS: 'participants',
} as const;

/** One per-conversation sub-route segment -- the type companion to {@link CHATS_VIEWER_SUBROUTES}. */
type ChatsViewerSubroute = (typeof CHATS_VIEWER_SUBROUTES)[keyof typeof CHATS_VIEWER_SUBROUTES];

/** `@runtime-derived-ssot-helper`: every segment comes from the SAME-FILE const SSOTs above (`CHATS_VIEWER_ROUTES`,
 *  `CHATS_VIEWER_SUBROUTES`). The id is URL-encoded inside the builder so no caller can compose the path without it; the
 *  worker's routing regex bypasses this helper (it needs an unescaped capture) but consumes the same constants. */
export function buildChatsConversationSubroute(conversationId: string, sub: ChatsViewerSubroute): string {
	return `${CHATS_VIEWER_ROUTES.CONVERSATIONS}/${encodeURIComponent(conversationId)}/${sub}`;
}

/** Read clamps bounding the viewer page and search reads; the worker applies them, so a client sending a different
 *  `limit` disagrees with the page it actually receives. */
export const CHATS_VIEWER_PAGING = {
	/** The viewer fetches 20 conversations per page, never the whole table. */
	DEFAULT_PAGE_SIZE: 20,
	MAX_PAGE_SIZE: 50,
	SEARCH_MAX_RESULTS: 100,
} as const;
